module.exports = __webpack_public_path__ + "static/media/galerija_2014 (44).85ace22e.jpg";